import { WeeklyScheduleScreen } from "@components";

export const WeeklySchedule = () => {
    return (
        <div>
            <WeeklyScheduleScreen />
        </div>
    );
};
